import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Checkbox,
  TextField
} from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { getQuoteProGroupsAttributeApi} from 'api';
import { updateQuoteProductGroups } from 'redux/actions/quote';
import useStyles from './styles';


const QuoteGroups = () => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const {
    editableQuoteProduct,
    quoteGroupsAttributeData
  } = useSelector((state: IReduxState) => state.quote);

  const groups = quoteGroupsAttributeData?.options?.filter((group) => !!group.value.length) || [];
  const currentGroupsIds = editableQuoteProduct?.custom_attributes
    .find((attr) => attr.attribute_code === 'catalog_quotepro_groups')?.value?.split(',') || [];
  const selectedGroupsById = () => (
    groups.filter((group) => currentGroupsIds.includes(group.value))
  );

  useEffect(() => {
    getQuoteProGroupsAttributeApi({dispatch});
  }, []);

  return (
    <div className="w-full">
      <Autocomplete
        multiple
        className={classes.autocomplete}
        options={groups}
        disableCloseOnSelect
        disableClearable
        value={selectedGroupsById()}
        getOptionLabel={(option) => option.label}
        renderOption={(option, { selected }) => (
          <>
            <Checkbox
              color="primary"
              checked={selected}
            />
            {option.label}
          </>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            size="small"
            label="Groups"
            placeholder="Add Listing to Group"
          />
        )}
        ChipProps={{
          className: classes.chip
        }}
        onChange={(event, value) => {
          dispatch(updateQuoteProductGroups(value.map((v) => (v as IQuoteGroup).value).join(',')));
        }}
      />
    </div>
  );
};

export default QuoteGroups;
